import { IUploadedItem } from '../../../types/file_uploader/uploaded_item/uploadedItem';
import { FileUploaderIcon } from '../FileUploaderIcon';
import { Button } from '../../Button';
import { TrashIcon, UploadIcon } from '../../../assets/Icons/index';
import TEXT from '../text.json';
import styles from './uploaded-item.module.scss';

export const UploadedItem = ({
    lang,
    fileType = 'file',
    fileName,
    fileSize,
    state = 'inprogress',
    onDelete,
    uploadAgainHandler,
    percentageCompleted = 0,
    failureReason
}: IUploadedItem) => {

    const LOCALIZED_TEXTS = TEXT[lang as keyof typeof TEXT] || TEXT.en;

    const fileSizeFormatter = (size: number) => {
        const ONE_MEGA_BYTE = 1024 * 1024;
        const ONE_KILO_BYTE = 1000;

        return (
            (size >= ONE_MEGA_BYTE) ?
                `${Math.floor(size / ONE_MEGA_BYTE)}MB`
                :
                (
                    (size >= ONE_KILO_BYTE) ?
                        `${Math.floor(size / ONE_KILO_BYTE)}KB`
                        :
                        `${size}Bytes`
                )
        )
    }

    return (
        <div
            className={styles['file-uploaded-item']}
            data-file-uploaded-item-state={state}
        >
            <div className={styles['file-uploaded-item__icon']}>
                <FileUploaderIcon
                    state={state}
                    icon={fileType}
                />
            </div>
            {
                state !== 'failed' ?
                    <div className={styles['file-uploaded-item__info-box']}>
                        <div className={styles['file-uploaded-item__info-box__file-details']}>
                            <div className={styles['file-uploaded-item__info-box__file-details__file-name']}>
                                {fileName && <div> {fileName} </div>}
                                {
                                    (percentageCompleted === 100 && state !== 'loading') &&
                                    <Button
                                        size='sm'
                                        variant='link'
                                        color='danger'
                                        leadingIcon={TrashIcon}
                                        onClickHandler={onDelete}
                                    />
                                }
                            </div>
                            {
                                fileSize &&
                                <div className={styles['file-uploaded-item__info-box__file-details__file-size']}>
                                    {fileSizeFormatter(Number(fileSize))}
                                </div>
                            }
                        </div>
                        <div className={styles['file-uploaded-item__info-box__progress-box']}>
                            <div className={styles['file-uploaded-item__info-box__progress-box__progress-track']}>
                                <div className={styles['file-uploaded-item__info-box__progress-box__progress-track__bar']}
                                    style={{ width: `${percentageCompleted}%` }}>
                                </div>
                            </div>
                            {state !== 'loading' && <div className={styles['file-uploaded-item__info-box__progress-box__percentage']}>{`${percentageCompleted}%`}</div>}
                        </div>
                    </div>
                    :
                    <div className={styles['file-uploaded-item__failed-info-box']}>
                        <div className={styles['file-uploaded-item__failed-info-box__upload-failed']}>
                            {failureReason/*  || LOCALIZED_TEXTS.uploadFailedTryAgain */}
                        </div>
                        <div className={styles['file-uploaded-item__failed-info-box__upload-info']}>
                            <div>{fileName}</div>
                            <div>
                                {
                                    `${fileSize ? `${fileSizeFormatter(Number(fileSize))} -` : ''}
                                ${percentageCompleted}%
                                ${LOCALIZED_TEXTS.uploaded}`
                                }
                            </div>
                        </div>
                        <Button
                            size='sm'
                            color='secondary'
                            variant='outlined'
                            text={LOCALIZED_TEXTS.uploadAgain}
                            leadingIcon={UploadIcon}
                            onClickHandler={uploadAgainHandler}
                        />
                    </div>
            }

        </div>
    )
}